module.exports = __webpack_public_path__ + "img/1.10de107b.png";